// FILECONTENT_START src/common/components/DataGrid/DataGridFilterIndicator.tsx
import {
  Box,
  BoxProps,
  Chip,
  ChipProps,
  Tooltip,
  useTheme,
} from "@mui/material";
import I18n from "i18n-js";
import { omit } from "lodash";
import { ReactNode } from "react";
import { appSettings } from "./../../bootstrap";
import { getColorsFromString } from "./../../modules/helpers";
export interface DataGridFilterIndicatorProps<F = any, O = any>
  extends BoxProps {
  item: F;
  options: O;
  applyFilter?: (item: F) => void;
  autoColor?: boolean;
  chipProps?: ChipProps;
  translationCategory?: string;
  attributesNotCount?: string[];
  renderItem?: (props: {
    key: string;
    field: string;
    fieldName?: string;
    label?: string;
    color?: string;
    backgroundColor?: string;
    deleteItem: Function;
    option: any;
  }) => ReactNode;
}

export default function DataGridFilterIndicator({
  item,
  options,
  applyFilter,
  autoColor,
  renderItem,
  chipProps,
  translationCategory,
  attributesNotCount,
  ...boxProps
}: DataGridFilterIndicatorProps) {
  const theme = useTheme();
  const onDelete = (isArray: boolean, field: string, value: any) => () => {
    let newItem = { ...item };
    if (isArray) {
      newItem[field] = newItem[field].filter(
        (val: any) => String(val) !== value
      );
      if (newItem[field].length === 0) {
        newItem = omit(newItem, field);
      }
    } else {
      newItem = omit(newItem, field);
    }
    applyFilter && applyFilter(newItem);
  };

  return (
    <Box {...boxProps}>
      {Object.keys(
        attributesNotCount ? omit(item, attributesNotCount) : item
      ).map((field: string) => {
        let value: any = item[field];
        let fieldName: string;
        if (translationCategory) {
          fieldName = I18n.t(`${translationCategory}.attributes.${field}`, {
            defaultValue: undefined,
          });
        }

        if (!value) {
          return null;
        }

        let isArray = true;
        if (!Array.isArray(value)) {
          value = [value];
          isArray = false;
        }

        return value.map((value: any, index: number) => {
          let label = value;
          let option: any;
          const key = `${field}[${index}]`;
          if (options[field]) {
            option = options[field].find(
              (o: any) => String(o.value) === String(value)
            );
            if (option) {
              label = option.label;
            }
          }

          let colors: any = {};
          if (autoColor) {
            colors = getColorsFromString(
              field,
              appSettings.constants?.autoColorOpacity
            );

            if (colors.color && theme.palette.mode === "dark") {
              colors.color = theme.palette.text.primary;
            }
          }
          if (renderItem) {
            return renderItem({
              key,
              field,
              fieldName,
              label,
              ...colors,
              option,
              deleteItem: onDelete(isArray, field, value),
            });
          }

          return (
            <Tooltip key={key} hidden={!fieldName} title={fieldName || ""}>
              <Chip
                sx={{
                  margin: 0.5,
                  ...colors,
                }}
                size="small"
                label={label}
                onDelete={onDelete(isArray, field, value)}
                {...chipProps}
              />
            </Tooltip>
          );
        });
      })}
    </Box>
  );
}

// FILECONTENT_END src/common/components/DataGrid/DataGridFilterIndicator.tsx